module.exports = __webpack_public_path__ + "img/bg3.d6060b3d.png";